import keidranPic from "@/public/images/artists/keidran.png";
import { Artist } from "@/types/types";

export const keidran = {
  id: "279",
  name: "Keidran",
  image: keidranPic,
  description: `Keidran's voice is bright and easy, with a smooth melodic feel that keeps things light, catchy, and moving.`,
  previewUrl:
    "https://public-assets.audimeestorage.com/artistPreviews%2Fkeidran-preview.mp3",
  meta: {
    free: false,
    new: false,
  },
  filters: {
    gender: "Male",
    tags: {
      primary: ["Unprocessed", "RnB", "Dance", "Pop", "Falsetto"],
      secondary: [],
    },
    pitchRange: {
      categories: {
        low: "Mid",
        high: "Mid",
      },
      specific: {
        low: 48,
        high: 68,
      },
      sweetSpot: 61,
    },
  },
} satisfies Artist;
